import { createHook } from "hook-creator";
import { QuickSearchAPIResponse, QuickSearchHookResult } from "app/search/interfaces";
import { getJsonFromUrl } from "app/main/functions";
import { getQuickSearchAPIUrl } from "app/search/urls";

const searchCache: { [key: string]: QuickSearchHookResult } = {};

let fetchTimeout: number;

const [useQuickSearchResults] = createHook(
    "useQuickSearchResults",
    (updateHooks: (searchTerm: string) => void) => (searchTerm: string) => {
        if (searchTerm.length <= 2 || typeof window === "undefined") {
            return [null, false];
        }

        const termKey = searchTerm.toLowerCase();
        let result = searchCache[termKey];

        if (!result) {
            result = [null, true];

            clearTimeout(fetchTimeout);
            fetchTimeout = window.setTimeout(() => {
                searchCache[termKey] = result;
                getJsonFromUrl<QuickSearchAPIResponse>(getQuickSearchAPIUrl(searchTerm)).then(({ results }) => {
                    result[1] = false;
                    result[0] = results ? results.filter((r: { isin: string }) => r.isin) : [];
                    updateHooks(searchTerm);
                });
            }, 500);
        }

        return result;
    }
);

export { useQuickSearchResults };
